// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s4-0";
export var leftAlign = "_s4-4";
export var listItem = "_s4-2";
export var listItemWrapper = "_s4-1";
export var operationText = "_s4-3";